import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/footer";
import AdminNav from "./admin_nav";

const AdminDashboard = () => {
	const [user, setuser] = useState();
	const navigate = useNavigate();

	useEffect(() => {
		const storedUser = localStorage.getItem("nguser");

		if (storedUser) {
			const admin = JSON.parse(storedUser);
			setuser(admin);
		} else {
			navigate("/");
		}
	}, [navigate]);

	useEffect(() => {
		if (user && user.role !== "admin") {
			console.warn("Non-admin user attempted to access admin dashboard.");
			localStorage.removeItem("nguser");
			navigate("/");
		}
	}, [user, navigate]);

	return (
		<div className="w-screen flex flex-col justify-center items-center">
			<AdminNav />
			<main className="w-screen px-4 md:px-20 pt-10 mt-16 lg:mt-20">
				<p className="text-2xl lg:text-5xl font-semibold text-gray-400">
					Welcome
				</p>
				<p className="text-3xl lg:text-7xl font-bold mt-4 lg:mt-8 text-gray-200">
					{user && user.name}
				</p>

				<div className="flex flex-col lg:flex-row lg:justify-around gap-10 mt-10 lg:mt-20">
					<div
						onClick={() => navigate("/admin/session")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/admin_cs.jpg"
							alt="Create Exercise"
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent">
							Create Session
						</p>
					</div>
					<div
						onClick={() => navigate("/admin/exercise")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/admin_ce.webp"
							alt="Create Session"
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent">
							Create Exercise
						</p>
					</div>
				</div>
			</main>
			<Footer />
		</div>
	);
};

export default AdminDashboard;
